export const HomeSliderNews = [
  
  {
    id: 30,
    cover: "../images/hero/ghanaready.jpg",
    category: "Events",
    title: "We are ready for the All Africans games - GCF",
    authorName: "Author Name",
    authorImg: "../images/hero/ghanaready.jpg",
    time: "05 Dec 2023",
    desc: [
      {
        para1: "Introduction or overview of the article",
      },
      {
        title: "Subheading 1"
      },
      {
        para1: "Content for subheading 1",
      },
      {
        para2: "Content for subheading 2",
      },
      // Add more paragraphs as needed
    ],
    details: [
      {
        title: "Author/Contributor Name",
      },
      {
        para1: "Main content or description by the author",
      },
      {
        quote: "Optional quote related to the article",
      },
      {
        para2: "Additional content or description",
      },
      
    ],
  },
  {
    id: 1,
    cover: "../images/hero/homeslider1.jpg",
    catgeory: "Administration",
    title: "Know your Executives",
    authorName: "Salman",
    authorImg: "../images/author.jpg",
    time: "5 Jun - 2022",
    desc: [
      {
        para1: "Get to know all your hardworking executives whose vision is steering our Federation at this point in time",
      },
      {
        title: "Osman Ansah (President)"
      }, 
      {
        para1: "Meet our esteemed President, Osman Ansah, a passionate advocate for cycling and sports development in Ghana. With a vision to elevate the Ghana Cycling Federation to new heights, he brings a wealth of experience and dedication to the cycling community.",
      },
      
      {
        para2: "Having successfully led various initiatives promoting healthy living and community engagement through cycling, Osman Ansah is committed to fostering a vibrant cycling culture across the nation.",
      },
      {
        para3: "We have a number of different teams within our agency that specialise in different areas of business so you can be sure that you won’t receive a generic service and although we can’t boast years and years of service we can ensure you that is a good thing in this industry.",
      },

      {
        para1: "Osman Ansah believes in the power of collaboration and innovation. Under his leadership, the federation has initiated programs to identify and nurture young cycling talents, ensuring a promising future for Ghana in international cycling competitions.",
      },
      {
        quote: "Cycling is not just a sport; it's a lifestyle. It promotes fitness, unity, and a sense of accomplishment. Together, we can pedal towards a healthier and more connected Ghana.",
      },
      {
        para2: "As a seasoned cyclist himself, Osman Ansah leads by example, often participating in cycling events to inspire others and promote the joy of cycling. His strategic vision and hands-on approach have contributed significantly to the growth of cycling in Ghana.",
      },
    ],
    details: [
      {
        title: "Ama Darko",
      },
      {
        para1: "Ama Darko envisions a future where cycling is accessible to everyone, irrespective of gender or background. Her advocacy for gender equality in sports has inspired positive changes within the federation and the broader cycling community.",
      },
      {
        quote: "Cycling knows no boundaries. It's a sport for all, and together, we can pedal towards a more inclusive and vibrant future.",
      },
      {
        para2: "Under Ama's leadership, the federation has launched mentorship programs, cycling clinics, and awareness campaigns to break down barriers and encourage diversity in the cycling community.",
      },
    ],
  },
  {
    id: 2,
    cover: "../images/hero/homeslider2.jpg",
    catgeory: "Talents",
    title: "Anthony Boakye on what it takes to be a world-class cyclist",
    authorName: "alex",
    authorImg: "../images/author.jpg",
    time: "12 Aug - 2022",
    desc: [
      {
        para1: "Discover the dedication, challenges, and triumphs that define the journey to becoming a world-class cyclist, from Ghana's finest.",
      },
      {
        para2: "Anthony's journey is a testament to the perseverance required to excel in the sport. From the rigorous training regimens to the mental fortitude needed during competitions, his experiences provide valuable lessons for aspiring cyclists and enthusiasts alike.",
      },
      {
        para3: "As we explore Anthony Boakye's narrative, we gain a deeper understanding of the passion that fuels his commitment to cycling and the impact it has on his life and the cycling community at large.",
      },
    ],
    details: [
      {
        title: "The Path to Cycling Excellence",
      },
      {
        para1: "Anthony Boakye shares insights on the challenges and triumphs he faced on his journey to becoming a world-class cyclist. From the early days of discovering his love for cycling to the intense training sessions that shaped his skills, his story is a source of inspiration for all cycling enthusiasts.",
      },
      {
        quote: "Cycling is more than a sport; it's a lifestyle. Anthony's dedication to continuous improvement and his pursuit of excellence set a high standard for aspiring cyclists worldwide.",
      },
      {
        para2: "In this exclusive interview, Anthony reflects on the evolving landscape of professional cycling, the importance of mental resilience, and the role of community support in achieving athletic goals. Join us as we uncover the secrets behind what it truly takes to be a world-class cyclist.",
      },
      {
        para3: "Whether you're a seasoned cyclist or a newcomer to the sport, Anthony Boakye's story offers valuable insights and motivation to propel you on your own cycling journey. Embrace the passion, face the challenges, and pedal towards excellence with Anthony Boakye as your guide.",
      },
    ],
  },

    {
      id: 3,
      cover: "../images/hero/homeslider3.jpg",
      catgeory: "Events",
      title: "Details of the Approved Programs and Events for 2024",
      authorName: "emma",
      authorImg: "../images/author.jpg",
      time: "20 Jan - 2024",
      desc: [
        {
          para1: "Get ready for an exhilarating lineup of activities designed to celebrate the spirit of cycling and foster community engagement.",
        },
        {
          para2: "From thrilling races that showcase the prowess of our cyclists to community-driven initiatives promoting cycling as a healthy lifestyle, the approved programs and events for 2024 promise an unforgettable experience for participants and spectators alike.",
        },
        {
          para3: "Join us in embracing the joy of cycling as we unveil the calendar of events, highlighting key dates, locations, and exciting features that make each program a unique and enriching experience for all members of the cycling community.",
        },
      ],
      details: [
        {
          title: "A Year of Cycling Excitement",
        },
        {
          para1: "The approved programs for 2024 reflect our commitment to promoting cycling at various levels, from grassroots initiatives to elite competitions. Each event is meticulously planned to offer participants a chance to showcase their skills, foster camaraderie, and inspire the next generation of cyclists.",
        },
        {
          quote: "Cycling is not just a sport; it's a community, a celebration, and a journey. In 2024, we invite you to be part of the cycling movement that transcends boundaries and brings people together through the love of riding.",
        },
        {
          para2: "Stay tuned as we unveil the specifics of each program, including categories, registration details, and special features that make them stand out. Whether you're a seasoned cyclist or a casual enthusiast, there's something for everyone in the diverse and exciting lineup of events for 2024.",
        },
        {
          para3: "Join us in making 2024 a year to remember for the cycling community. Together, let's pedal towards new adventures, shared experiences, and the thrill of discovering the joy of cycling in all its forms.",
        },
      ],
    },
    // Add more data for other programs and events
]

export const popular = [
  {
    id: 4,
    cover: "../images/Articles/ExtraOrdinaryMeeting.jpg",
    catgeory: "Administration",
    title: "Ghana Cycling Federation Holds Extra Ordinary Meeting",
    authorName: "Salman",
    authorImg: "../images/author.jpg",
    time: "23 Nov - 2023",
    desc: [
      {
        para1: "The AGM was organized physically and virtually to finally approve its amended constitution which has already been given the green light for operations in its upcoming activities.",
      },
      {
        para2: "The Congress which came off at the conference room of the Ghana Olympic committee among the twenty-six (26) clubs in Ghana, saw fifteen (15) clubs representing physically with four (4) clubs joining via the Zoom link. Seven(7) clubs were absent.",
      },
      {
        para3: "The twenty-six cycling clubs were from various regions in Ghana, North East, Northern, Savana, BA, Ashanti, Volta, Eastern, Central, Western, and Greater Accra, three clubs from three regions (Oti, Upper East, and Upper West) application is ready for congress approval.",
      },
    ],
    details: [
      {
        title: "The Ghana Cycling Federation held its Extra ordinary meeting on November 19.",
      },
      { para1: "The significant change in the constitution is how, for the first time in the history of the Sport, a Management Committee would be in place. This committee would be drawn from four elected persons from the national, one elected person from each region of the country where cycling club/s represent and some appointments including athletes representative on both regular cycling and Para-cycling." },
      {
        quote: "It is therefore expected to see more than 20 Management members in the new administration who, in turn, would appoint/elect officers to run the Federation after the 2022 elective congress slated for Wednesday 28th December this year.",
      },

    ],
  },
  {
    id: 5,
    cover: "../images/Articles/ghanatohostevent.jpg",
    catgeory: "Events",
    title: "Ghana to host a new Cycling Event",
    authorName: " ",
    authorImg: "../images/author.jpg",
    time: "12 Aug - 2023",
    desc: [
      {
        para1: "You audience. Least, the recently his repeat the this avarice for the have and was on would before the concise bedding were hall politely name be regretting have of even five of it the his are there again. Word seven designer far lady problem will have work with you to fully understand your business to achieve.",
      },
      {
        para2: "We work with clients big and small across a range of sectors and we utilize all forms of media to get your name out there in a way that’s right for you. We believe that analysis of your company and your customers is key in responding effectively to your promotional needs and we will work with you.",
      },
      {
        para3: "We have a number of different teams within our agency that specialise in different areas of business so you can be sure that you won’t receive a generic service and although we can’t boast years and years of service we can ensure you that is a good thing in this industry.",
      },
    ],
    details: [
      {
        title: "Starting a new company is easy",
      },
      { para1: "Our teams are up to date with the latest technologies, media trends and are keen to prove themselves in this industry and that’s what you want from an advertising agency, not someone who is relying on the same way of doing things that worked 10 years, 5 years or even a year ago." },
      {
        quote: "Scarfs, still not this no with explains it me and option on the any options roasted when I and state can that an don't subjective of has his take on and in from royal everything took raising our have behind success you the mechanic.",
      },
      {
        para2: "And, higher by agency; In from their in and we spirit, through merely and doctor's small him sounded a all now, with that put gift white highly geared that was left back as of or logged important. A over have the large try understanding the believe. Perfected been viewer. Shreds early willingly safely what passion the.",
      },
      {
        para3: "In an ideal world this website wouldn’t exist, a client would acknowledge the importance of having web copy before the design starts. Needless to say it’s very important, content is king and people are beginning to understand that. However, back over in reality some project schedules and budgets don’t allow for web copy to be written before the design phase, this is sad but true.",
      },
    ],
  },
  {
    id: 6,
    cover: "../images/Articles/GhanaCyclingFedfemaleCyclists.jpg",
    catgeory: "Talents",
    title: "How to join a Cycling Club",
    authorName: "rina",
    authorImg: "../images/author.jpg",
    time: "22 Mar - 2022",
    desc: [
      {
        para1: "You audience. Least, the recently his repeat the this avarice for the have and was on would before the concise bedding were hall politely name be regretting have of even five of it the his are there again. Word seven designer far lady problem will have work with you to fully understand your business to achieve.",
      },
      {
        para2: "We work with clients big and small across a range of sectors and we utilize all forms of media to get your name out there in a way that’s right for you. We believe that analysis of your company and your customers is key in responding effectively to your promotional needs and we will work with you.",
      },
      {
        para3: "We have a number of different teams within our agency that specialise in different areas of business so you can be sure that you won’t receive a generic service and although we can’t boast years and years of service we can ensure you that is a good thing in this industry.",
      },
    ],
    details: [
      {
        title: "Starting a new company is easy",
      },
      { para1: "Our teams are up to date with the latest technologies, media trends and are keen to prove themselves in this industry and that’s what you want from an advertising agency, not someone who is relying on the same way of doing things that worked 10 years, 5 years or even a year ago." },
      {
        quote: "Scarfs, still not this no with explains it me and option on the any options roasted when I and state can that an don't subjective of has his take on and in from royal everything took raising our have behind success you the mechanic.",
      },
      {
        para2: "And, higher by agency; In from their in and we spirit, through merely and doctor's small him sounded a all now, with that put gift white highly geared that was left back as of or logged important. A over have the large try understanding the believe. Perfected been viewer. Shreds early willingly safely what passion the.",
      },
      {
        para3: "In an ideal world this website wouldn’t exist, a client would acknowledge the importance of having web copy before the design starts. Needless to say it’s very important, content is king and people are beginning to understand that. However, back over in reality some project schedules and budgets don’t allow for web copy to be written before the design phase, this is sad but true.",
      },
    ],
  },
  {
    id: 7,
    cover: "../images/Articles/amputeekids.jpg",
    catgeory: "Talents",
    title: "The Catch them Young Initiative",
    authorName: "sunil",
    authorImg: "../images/author.jpg",
    time: "08 Dec - 2022",
    desc: [
      {
        para1: "You audience. Least, the recently his repeat the this avarice for the have and was on would before the concise bedding were hall politely name be regretting have of even five of it the his are there again. Word seven designer far lady problem will have work with you to fully understand your business to achieve.",
      },
      {
        para2: "We work with clients big and small across a range of sectors and we utilize all forms of media to get your name out there in a way that’s right for you. We believe that analysis of your company and your customers is key in responding effectively to your promotional needs and we will work with you.",
      },
      {
        para3: "We have a number of different teams within our agency that specialise in different areas of business so you can be sure that you won’t receive a generic service and although we can’t boast years and years of service we can ensure you that is a good thing in this industry.",
      },
    ],
    details: [
      {
        title: "Starting a new company is easy",
      },
      { para1: "Our teams are up to date with the latest technologies, media trends and are keen to prove themselves in this industry and that’s what you want from an advertising agency, not someone who is relying on the same way of doing things that worked 10 years, 5 years or even a year ago." },
      {
        quote: "Scarfs, still not this no with explains it me and option on the any options roasted when I and state can that an don't subjective of has his take on and in from royal everything took raising our have behind success you the mechanic.",
      },
      {
        para2: "And, higher by agency; In from their in and we spirit, through merely and doctor's small him sounded a all now, with that put gift white highly geared that was left back as of or logged important. A over have the large try understanding the believe. Perfected been viewer. Shreds early willingly safely what passion the.",
      },
      {
        para3: "In an ideal world this website wouldn’t exist, a client would acknowledge the importance of having web copy before the design starts. Needless to say it’s very important, content is king and people are beginning to understand that. However, back over in reality some project schedules and budgets don’t allow for web copy to be written before the design phase, this is sad but true.",
      },
    ],
  },
]


export const Articles = [
  {
    id: 8,
    category: "Travel",
    title: "Team Ghana Gears Up for International Cycling Championship in Brazil",
    date: "19. January 2023",
    cover: "../images/Articles/travel.jpg",
    authorName: "John Doe",
    authorImg: "../images/author.jpg",
    time: "10:00 AM",
    desc: [
      {
        para1: "Team Ghana, composed of elite cyclists from various regions, is all set to represent the country in the upcoming International Cycling Championship in Brazil.",
      },
      {
        para2: "The cyclists have undergone rigorous training sessions, focusing on endurance, speed, and strategic race tactics. The team is optimistic about showcasing their skills and bringing honor to the nation.",
      },
      {
        para3: "Fans and supporters are eagerly anticipating the thrilling competition, and Team Ghana is determined to make the country proud on the international stage.",
      },
    ],
    details: [
      {
        title: "Countdown to the Championship",
      },
      {
        para1: "The championship is scheduled to take place on January 25, 2023, in Brazil. Team Ghana has been preparing for months, ensuring that they are in peak condition for the prestigious event.",
      },
      {
        quote: "We are not just competing; we are representing the spirit of Ghana. Our goal is to leave a lasting impression and inspire aspiring cyclists back home.",
      },
    ],
  },
  {
    id: 9,
    category: "Events",
    title: "Ghana Celebrates Victory at West African Cycling Tour",
    date: "19. February 2023",
    cover: "../images/Articles/ghanaWinsCyclingCompetition.png",
    authorName: "Ama Asante",
    authorImg: "../images/author.jpg",
    time: "2:30 PM",
    desc: [
      {
        para1: "Ghana emerged triumphant at the recently concluded West African Cycling Tour, securing top positions in multiple categories. The event, held in Nigeria, witnessed fierce competition among cycling enthusiasts from the West African region.",
      },
      {
        para2: "The Ghanaian cyclists showcased exceptional skills and determination, dominating the tour and clinching several podium finishes. The victories have brought immense pride and joy to the cycling community and the nation as a whole.",
      },
      {
        para3: "The cycling federation and fans are extending heartfelt congratulations to the athletes, recognizing their hard work, discipline, and dedication that led to this remarkable achievement.",
      },
    ],
    details: [
      {
        title: "Notable Achievements",
      },
      {
        para1: "Ghana secured first place in the men's and women's individual time trials, demonstrating outstanding individual performances. The team also excelled in the team road races, solidifying their overall dominance in the competition.",
      },
      {
        quote: "This victory is a testament to the talent and commitment of our cyclists. It's a proud moment for Ghanaian cycling, and we look forward to building on this success in future competitions.",
      },
    ],
  },

  {
    id: 10,
    category: "News",
    title: "New Cycling Infrastructure Boosts Community Engagement",
    date: "10. October 2023",
    cover: "../images/Articles/girlsInCycling.png",
    authorName: "Cyclist Enthusiast",
    authorImg: "../images/author.jpg",
    time: "11:45 AM",
    desc: [
      {
        para1: "In a groundbreaking initiative, local communities are experiencing a surge in cycling activities thanks to the implementation of modern cycling infrastructure.",
      },
      {
        para2: "The newly constructed cycling lanes, bike-sharing stations, and repair hubs have not only enhanced the overall cycling experience but also fostered a sense of community among cyclists and residents.",
      },
      {
        para3: "Residents are praising the positive impact on health, reduced traffic congestion, and the environmentally friendly nature of the new cycling facilities.",
      },
    ],
    details: [
      {
        title: "Community Transformation Through Cycling",
      },
      {
        para1: "The cycling infrastructure project, funded by local authorities and cycling advocacy groups, aims to promote a healthier and more sustainable lifestyle. Cycling enthusiasts and beginners alike are embracing the convenience and safety provided by the new facilities.",
      },
      {
        quote: "The community is now more connected than ever, and the positive response has exceeded our expectations. This project serves as a model for other regions looking to prioritize cycling as a means of transportation and recreation.",
      },
    ],
  },
  {
    id: 11,
    category: "Regional",
    title: "Excitement Builds as Eastern Region Prepares to Face Bono East in Maiden Cycling Event",
    date: "19. August 2023",
    cover: "../images/Articles/ContinentalChampionship.jpg",
    authorName: "Sarah Ofori",
    authorImg: "../images/author.jpg",
    time: "3:15 PM",
    desc: [
      {
        para1: "Cycling enthusiasts in the Eastern Region are eagerly anticipating the upcoming cycling event that will see a friendly competition between the Eastern Region and Bono East.",
      },
      {
        para2: "The event, scheduled for August 25, 2023, is the first of its kind, fostering camaraderie and healthy competition between the two regions. Cyclists from both regions have been undergoing intense training to showcase their skills and bring glory to their respective areas.",
      },
      {
        para3: "Residents and cycling fans are expected to gather in large numbers to witness the thrilling races and support their local teams. The event promises to be a celebration of sportsmanship, unity, and the growing cycling culture in the region.",
      },
    ],
    details: [
      {
        title: "Anticipated Highlights of the Event",
      },
      {
        para1: "The cycling event will feature a series of races, including individual time trials, team road races, and sprints. Cyclists from different age groups and skill levels will participate, showcasing the diversity and talent within the cycling communities of both regions.",
      },
      {
        quote: "This event is not just about competition; it's about bringing people together and promoting the joy of cycling. We hope to make this an annual tradition that strengthens the bond between Eastern Region and Bono East through the shared love of cycling.",
      },
    ],
  },
  

  {
    id: 12,
    category: "How to",
    title: "Mastering the Art of Cycling: How to Ride Like a Mustang",
    date: "19. August 2023",
    cover: "../images/Articles/life1.jpg",
    authorName: "Cycling Guru",
    authorImg: "../images/author.jpg",
    time: "9:30 AM",
    desc: [
      {
        para1: "Cycling, much like the spirit of a Mustang, embodies power, freedom, and a thrilling sense of adventure. In this guide, we'll explore essential tips to help you ride like a Mustang and elevate your cycling experience to new heights.",
      },
      {
        para2: "1. **Embrace the Open Road**: A Mustang doesn't shy away from the open road, and neither should you. Explore new cycling routes, embrace scenic trails, and let the wind be your companion.",
      },
      {
        para3: "2. **Build Endurance**: Mustangs are known for their stamina. To ride like a Mustang, focus on building your endurance through regular and challenging cycling workouts. Gradually increase your mileage and push your limits.",
      },
    ],
    details: [
      {
        title: "Tips for Riding Like a Mustang",
      },
      {
        para1: "3. **Maintain Speed with Precision**: Mustangs are swift and precise in their movements. Work on maintaining a consistent and controlled speed. Practice braking and cornering techniques to enhance your overall cycling performance.",
      },
      {
        quote: "Riding like a Mustang is not just about speed; it's about mastering control and precision. Strive for a harmonious balance between power and finesse.",
      },
      {
        para2: "4. **Equip Yourself Properly**: Just as a Mustang needs the right gear, ensure you have the proper cycling equipment. Invest in a quality bike, wear protective gear, and keep your bike well-maintained for optimal performance.",
      },
      {
        para3: "5. **Embody the Spirit of Freedom**: Lastly, embrace the spirit of freedom that defines a Mustang. Let go of any inhibitions, enjoy the ride, and let the joy of cycling fuel your sense of adventure and liberation.",
      },
    ],
  },
  

  {
    id: 13,
    category: "Infrastructure",
    title: "Revolutionizing Cycling: Ghana's Initiative to Acquire Modern Bicycles",
    date: "20. September 2023",
    cover: "../images/Articles/modernBike.jpg",
    authorName: "Infrastructure Enthusiast",
    authorImg: "../images/author.jpg",
    time: "2:00 PM",
    desc: [
      {
        para1: "In a significant move to promote sustainable transportation and enhance the cycling experience, Ghana is set to acquire a fleet of modern bicycles equipped with advanced features and technology.",
      },
      {
        para2: "The initiative, spearheaded by the government and cycling advocacy groups, aims to provide the public with access to state-of-the-art bicycles that prioritize safety, comfort, and eco-friendliness.",
      },
      {
        para3: "This investment in modern bicycles aligns with the country's commitment to fostering a cycling-friendly environment, reducing carbon emissions, and promoting a healthier lifestyle.",
      },
    ],
    details: [
      {
        title: "Key Features of the Modern Bicycles",
      },
      {
        para1: "1. **Smart Connectivity**: The modern bicycles will come equipped with smart technology, allowing cyclists to track their rides, access navigation features, and connect with fellow cyclists through a dedicated mobile app.",
      },
      {
        quote: "Ghana's move towards modern bicycles is a testament to our commitment to innovation and sustainability. These bicycles are not just a mode of transportation; they represent a step towards a greener and healthier future.",
      },
      {
        para2: "2. **Enhanced Safety Features**: Safety is a top priority. The bicycles will feature advanced safety mechanisms, including built-in lights, reflective materials, and responsive braking systems to ensure a secure riding experience.",
      },
      {
        para3: "3. **Eco-Friendly Design**: The bicycles will be manufactured with eco-friendly materials, contributing to the reduction of environmental impact. This aligns with Ghana's efforts to promote sustainable practices and combat climate change.",
      },
    ],
  },

  {
    id: 14,
    category: "Talents",
    title: "Yussif Abubakari: GCF Has Given Me the Opportunity to Make Ghana Proud",
    date: "6. February 2023",
    cover: "../images/Articles/training.webp",
    authorName: "Yussif Abubakari",
    authorImg: "../images/athlete.jpg",
    time: "4:45 PM",
    desc: [
      {
        para1: "In an exclusive interview, Yussif Abubakari, a rising star in the world of cycling, shares his journey and experiences with the Ghana Cycling Federation (GCF), highlighting the significant impact it has had on his career and aspirations.",
      },
      {
        para2: "Abubakari expresses gratitude to the GCF for providing him with the platform and support to showcase his talents on both national and international stages. He emphasizes how the federation's initiatives have opened doors for him to compete, learn, and grow as a professional cyclist.",
      },
      {
        para3: "The talented cyclist is determined to make Ghana proud and contribute to the growth of cycling in the country. Abubakari's story serves as an inspiration to aspiring cyclists, demonstrating the opportunities that can arise through dedication and the right support system.",
      },
    ],
    details: [
      {
        title: "Yussif Abubakari's Achievements",
      },
      {
        para1: "Yussif Abubakari, hailing from [City], has achieved remarkable success in various cycling competitions, securing podium finishes and earning recognition for his exceptional skills.",
      },
      {
        quote: "The GCF has been instrumental in shaping my career. It's not just about winning races; it's about representing Ghana and inspiring others to pursue their passion for cycling. I am committed to giving my best and making my country proud.",
      },
      {
        para2: "Abubakari encourages young talents to embrace the opportunities provided by organizations like the GCF and to pursue their dreams with determination. As he continues to train and compete, Yussif Abubakari remains a symbol of talent, dedication, and the potential for greatness within the Ghanaian cycling community.",
      },
    ],
  },
  

  {
    id: 15,
    category: "Corporate",
    title: "Corporate Support Surges as More Companies Pledge Their Backing for Ghana",
    date: "12. October 2023",
    cover: "../images/Articles/ghanaCommonwealthGames.jpg",
    authorName: "Corporate Reporter",
    authorImg: "../images/reporter.jpg",
    time: "10:30 AM",
    desc: [
      {
        para1: "In a promising development for Ghanaian cycling, a growing number of corporate entities are stepping forward to pledge their support for the sport. This surge in corporate backing is expected to significantly boost the resources available for the development of cycling in the country.",
      },
      {
        para2: "The commitment from various companies comes at a crucial time for the Ghana Cycling Federation (GCF), as they prepare for upcoming national and international competitions. The increased financial and logistical support is anticipated to enhance training programs, infrastructure, and the overall competitiveness of Ghanaian cyclists.",
      },
      {
        para3: "Representatives from the corporate sector express their enthusiasm for partnering with the GCF, recognizing the potential of cycling as a platform for promoting health, unity, and national pride.",
      },
    ],
    details: [
      {
        title: "Growing Corporate Partnerships",
      },
      {
        para1: "Several prominent companies, including [Company A], [Company B], and [Company C], have officially pledged their support for Ghanaian cycling. These partnerships extend beyond financial contributions, with companies actively engaging in initiatives to promote the sport at the grassroots level.",
      },
      {
        quote: "Our commitment to supporting Ghanaian cycling is driven by the belief in the positive impact sports can have on communities. We see cycling as a catalyst for unity and empowerment, and we are proud to be part of this journey with the Ghana Cycling Federation.",
      },
      {
        para2: "The GCF welcomes the support from the corporate sector and expresses gratitude for the shared vision of advancing the sport in Ghana. As these partnerships continue to flourish, the future looks promising for the growth and success of cycling in the country.",
      },
    ],
  },
  
  {
    id: 16,
    category: "Events",
    title: "National Congress Preview: A Quick Look at What to Expect This Year",
    date: "25. October 2023",
    cover: "../images/hero/homeslider1.jpg",
    authorName: "Event Correspondent",
    authorImg: "../images/correspondent.jpg",
    time: "1:15 PM",
    desc: [
      {
        para1: "As the date for the annual National Cycling Congress approaches, anticipation is building within the cycling community. The National Congress, a pivotal event organized by the Ghana Cycling Federation (GCF), serves as a platform for discussions, decisions, and strategic planning to shape the future of cycling in the country.",
      },
      {
        para2: "This year's Congress promises to be a dynamic and engaging event, bringing together key stakeholders, cycling enthusiasts, and experts to address critical issues, share insights, and celebrate the achievements of the past year.",
      },
      {
        para3: "Cyclists, officials, and supporters are eager to gain a comprehensive understanding of the initiatives, policies, and advancements that will shape the landscape of Ghanaian cycling in the coming year.",
      },
    ],
    details: [
      {
        title: "Highlights of the National Congress",
      },
      {
        para1: "1. **Strategic Planning**: The Congress will feature discussions on strategic plans for the development of cycling at the national and grassroots levels. Key priorities, initiatives, and goals for the upcoming year will be outlined.",
      },
      {
        quote: "The National Congress is a critical juncture for fostering collaboration and unity within the cycling community. It provides a platform for diverse voices to contribute to the growth and success of Ghanaian cycling.",
      },
      {
        para2: "2. **Recognition and Awards**: Notable achievements and contributions to Ghanaian cycling will be recognized and celebrated. Awards will be presented to individuals and organizations that have played a significant role in advancing the sport.",
      },
      {
        para3: "3. **Open Forum Discussions**: An open forum will provide participants with the opportunity to voice their opinions, share ideas, and contribute to the ongoing dialogue about the challenges and opportunities within the cycling community.",
      },
    ],
  },

]

export const tpost = [
  {
    id: 17,
    title: "How to keep your bicycle in shape",
    cover: "../images/tpost/strongBike.png",
  },
  {
    id: 18,
    title: "Ride like your life depends on it",
    cover: "../images/tpost/celebration.jpg",
  },
  {
    id: 19,
    title: "Brothers on the wheels",
    cover: "../images/tpost/tpost3.jpg",
  },
]

export const Events = [
  {
    id: 1,
    catgeory: "Events",
    title: "Tour du Accra ",
    date: " - 19th February, 2024",
    cover: " ",
  },
  {
    id: 2,
    catgeory: "Events",
    title: "Cross Country Ghana ",
    date: " - 6th May, 2024",
    cover: "../images/life/life2.jpg",
  },
  {
    id: 3,
    catgeory: "Event",
    title: "Junior Cup Challenged ",
    date: " - 8th July, 2024",
    cover: "",
  },
  {
    id: 4,
    catgeory: "Event",
    title: "Gold Challenge",
    date: " - 30th August, 2024",
    cover: " ",
  },
]

